export default __webpack_public_path__ + "static/media/dropdown.ddb5555c.svg";